import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IEmployeeActivitiesGetAllParams } from "@api/stores/employeeActivities/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  IEmployeeActivitiesGetAllParams
>("stores.employeeActivities.exportPDF");

export const exportPDF = {
  ...getApis,
};
